import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { FormFieldProps, Form, Label } from 'semantic-ui-react'

interface IProps extends FieldRenderProps<string, HTMLElement>, FormFieldProps { }

export const TextAreaInput: React.FC<IProps> = ({ input, width, rows, placeholder, meta: { touched, error }, label, maxlength, readOnly }) => {
    return (
        <Form.Field error={touched && !!error} width={width}>
            {label && <label>{label}</label>}
            <textarea {...input} rows={rows} placeholder={placeholder} maxLength={maxlength} readOnly={readOnly}/>
            {touched && error && (
                <Label basic color='red' pointing='above'>{error}</Label>
            )}
        </Form.Field>
    )
}
